import React, { useMemo } from "react";
import { ShieldAlert, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";

const WA_NUMBER = "5561996011975";

function buildWhatsAppLink(text) {
  const base = `https://wa.me/${WA_NUMBER}`;
  const msg = encodeURIComponent(text || "Olá! Sou cliente do GSCRM e preciso regularizar meu pagamento.");
  return `${base}?text=${msg}`;
}

export default function Inadimplente({ user }) {
  const navigate = useNavigate();
  const pathname = window.location.pathname.toLowerCase();

  // ✅ verifica se está nas rotas de formulário
  const isFormRoute = pathname.includes("/formularios/") || pathname.includes("/preencher/");

  const msg = useMemo(() => {
    const id = user?.id || user?._id || "";
    const email = user?.email || "";
    const company = user?.company || user?.empresa || "";
    const ref = [company, email, id].filter(Boolean).join(" | ");
    return `Olá, Gabriel! Meu acesso ao GSCRM foi suspenso por inadimplência. Dados: ${ref}. Pode me ajudar a regularizar?`;
  }, [user]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#0b1220",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 640,
          background: "white",
          borderRadius: 16,
          boxShadow: "0 10px 30px rgba(0,0,0,.15)",
          padding: 28,
          textAlign: "center",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: 12,
              background: "#fff3cd",
              color: "#664d03",
              display: "grid",
              placeItems: "center",
              fontSize: 0,
            }}
          >
            <ShieldAlert size={36} />
          </div>
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 8 }}>
          Serviço suspenso por falta de pagamento
        </h1>
        <p
          style={{
            fontSize: 15,
            color: "#4b5563",
            margin: "0 auto 20px",
            maxWidth: 520,
          }}
        >
          O acesso ao <strong>GSCRM</strong> foi temporariamente desativado porque há mensalidade(s) em atraso.
          Assim que o pagamento for regularizado, seu login será restabelecido automaticamente.
        </p>

        {/* 🔒 Só mostra o botão se NÃO for rota de formulário */}
        {!isFormRoute && (
          <>
            <a
              href={buildWhatsAppLink(msg)}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
                background: "#25D366",
                color: "white",
                padding: "12px 18px",
                borderRadius: 12,
                fontWeight: 700,
                textDecoration: "none",
                boxShadow: "0 6px 14px rgba(37,211,102,.35)",
              }}
            >
              <Phone size={18} />
              Falar no WhatsApp
            </a>

            <div style={{ marginTop: 18, fontSize: 13, color: "#6b7280" }}>
              Número: <strong>{WA_NUMBER}</strong>
            </div>

            {/* <button
              onClick={() => navigate("/")}
              style={{
                marginTop: 24,
                background: "transparent",
                border: "1px solid #E5E7EB",
                color: "#374151",
                padding: "10px 14px",
                borderRadius: 10,
                cursor: "pointer",
              }}
            >
              Voltar para a página inicial
            </button> */}
          </>
        )}
      </div>
    </div>
  );
}
